// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.global.js
// module id = 1343
// module chunks = 168707334958949